import { CircularProgress, styled } from "@mui/material";

import { Row } from "../layout";

export const Spinner = styled(CircularProgress)(({ theme }) => ({
  fontSize: theme.spacing(3.5),

  "& .MuiCircularProgress-svg": {
    color: theme.palette.grey[700],
  },
}));

interface SizedBoxProps {
  size: number | string;
}

export const SizedBox = styled(Row, {
  shouldForwardProp: (propName: keyof SizedBoxProps) => propName !== "size",
})<SizedBoxProps>(({ size }) => ({
  justifyContent: "center",
  overflow: "hidden",
  height: size,
  width: size,
}));
